import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IContextualMenuProps } from "@fluentui/react";

import type { DeferredMenuDefinition, MenuDefinition } from "../MenuDefinition";

export interface MenuAnchorContextType {
  /**
   * The anchor's deferred menu definition that contains information required to generate the full menu definition
   * from the store when required.
   */
  deferredMenuDefinition?: DeferredMenuDefinition;

  /**
   * Each control has some custom way it wants its menu props to be. This callback will be used to generate
   * full menu props from menuDefinition that itself would have been generated from the deferredMenuDefinition
   */
  getMenuPropsFromMenuDefinition?: (
    menuDefinition: MenuDefinition
  ) => IContextualMenuProps;
}

/**
 * Default value of MenuAnchorContext
 */
export const DefaultMenuAnchorContext: MenuAnchorContextType = {};

/**
 * When menus are directly connected to the store, there will be some information that we need to provide
 * so that the menu is able to generate its full props. Since, there are other Fabric components in between
 * we use React context to bypass those and to pass this information so that we can use it to generate
 * full menu props.
 */
export const MenuAnchorContext = React.createContext<MenuAnchorContextType>(
  DefaultMenuAnchorContext
);
MenuAnchorContext.displayName = "MenuAnchorContext";
